var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 3.75H21.5625C22.3084 3.75 23.0238 4.04632 23.5512 4.57376C24.0787 5.10121 24.375 5.81658 24.375 6.5625V25.3125C24.375 26.0584 24.0787 26.7738 23.5512 27.3012C23.0238 27.8287 22.3084 28.125 21.5625 28.125H8.4375C7.69158 28.125 6.97621 27.8287 6.44876 27.3012C5.92132 26.7738 5.625 26.0584 5.625 25.3125V6.5625C5.625 5.81658 5.92132 5.10121 6.44876 4.57376C6.97621 4.04632 7.69158 3.75 8.4375 3.75H12.1875",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 3.75H21.5625C22.3084 3.75 23.0238 4.04632 23.5512 4.57376C24.0787 5.10121 24.375 5.81658 24.375 6.5625V25.3125C24.375 26.0584 24.0787 26.7738 23.5512 27.3012C23.0238 27.8287 22.3084 28.125 21.5625 28.125H8.4375C7.69158 28.125 6.97621 27.8287 6.44876 27.3012C5.92132 26.7738 5.625 26.0584 5.625 25.3125V6.5625C5.625 5.81658 5.92132 5.10121 6.44876 4.57376C6.97621 4.04632 7.69158 3.75 8.4375 3.75H12.1875",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 1.50012H11.9062C11.5312 1.50012 11.25 1.96887 11.25 2.43762V4.40637C11.25 4.87512 11.5312 5.25012 11.9062 5.25012H18.0938C18.4688 5.25012 18.75 4.87512 18.75 4.40637V2.43762C18.75 1.96887 18.4688 1.50012 18.0938 1.50012Z",
    fill: "#AA013F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75C16.0312 3.75 16.875 2.90625 16.875 1.875C16.875 0.84375 16.0312 0 15 0C13.9688 0 13.125 0.84375 13.125 1.875C13.125 2.90625 13.9688 3.75 15 3.75Z",
    fill: "#AA013F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25H15.9375",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15H17.8125",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.875C21.5729 16.875 20.6666 17.1499 19.8958 17.665C19.1249 18.1801 18.5241 18.9121 18.1693 19.7687C17.8145 20.6252 17.7217 21.5677 17.9026 22.477C18.0834 23.3863 18.5299 24.2215 19.1854 24.8771C19.841 25.5326 20.6762 25.9791 21.5855 26.1599C22.4948 26.3408 23.4373 26.248 24.2938 25.8932C25.1504 25.5384 25.8824 24.9376 26.3975 24.1667C26.9126 23.3959 27.1875 22.4896 27.1875 21.5625C27.1874 20.3193 26.6935 19.1271 25.8145 18.248C24.9354 17.369 23.7432 16.8751 22.5 16.875Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.875C21.5729 16.875 20.6666 17.1499 19.8958 17.665C19.1249 18.1801 18.5241 18.9121 18.1693 19.7687C17.8145 20.6252 17.7217 21.5677 17.9026 22.477C18.0834 23.3863 18.5299 24.2215 19.1854 24.8771C19.841 25.5326 20.6762 25.9791 21.5855 26.1599C22.4948 26.3408 23.4373 26.248 24.2938 25.8932C25.1504 25.5384 25.8824 24.9376 26.3975 24.1667C26.9126 23.3959 27.1875 22.4896 27.1875 21.5625C27.1874 20.3193 26.6935 19.1271 25.8145 18.248C24.9354 17.369 23.7432 16.8751 22.5 16.875Z",
    fill: "white",
    stroke: "#02006B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 25.3125L29.0625 28.125L26.25 25.3125Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 25.3125L29.0625 28.125",
    stroke: "#02006B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyDoc);
export default __webpack_public_path__ + "static/media/MagnifyDoc.999cf1da6fa9e98a35944b5df1f01ece.svg";
export { ForwardRef as ReactComponent };